(function () {
  if (window.RSCart) return;

  var cfgEl = document.getElementById('rs-atc-config');
  var CFG = cfgEl ? JSON.parse(cfgEl.textContent) : {};
  var root = CFG.root || '/';
  if (root.slice(-1) !== '/') root += '/';
  var cartUrl = root + 'cart';
  var checkoutUrl = root + 'checkout';
  var PENDING_KEY = 'rs_atc_toast';
  var FREE_SHIP = CFG.freeShipCents || 3900;

  function track(name, key, value) {
    try {
      if (!window.clarity) return;
      window.clarity('event', name);
      if (key) window.clarity('set', key, String(value));
    } catch (e) {}
  }

  function pickVariant() {
    var forced = new URLSearchParams(window.location.search).get('rs_atc');
    var stored = null;
    try { stored = localStorage.getItem('rs_atc_variant'); } catch (e) {}
    var variant = forced === 'toast' || forced === 'cart' ? forced : stored;
    if (variant !== 'toast' && variant !== 'cart') {
      variant = Math.random() < 0.5 ? 'toast' : 'cart';
    }
    try { localStorage.setItem('rs_atc_variant', variant); } catch (e) {}
    return variant;
  }

  var VARIANT = pickVariant();
  var lockScrollY = 0;
  var sheetExitToCart = false;
  var sheetExitToCheckout = false;
  try { if (window.clarity) window.clarity('set', 'rs_atc_variant', VARIANT); } catch (e) {}

  function lockPageScroll() {
    lockScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    document.documentElement.classList.add('rs-atc-lock');
    document.body.classList.add('rs-atc-lock');
    document.body.style.top = '-' + lockScrollY + 'px';
  }

  function unlockPageScroll() {
    document.documentElement.classList.remove('rs-atc-lock');
    document.body.classList.remove('rs-atc-lock');
    document.body.style.top = '';
    window.scrollTo(0, lockScrollY);
  }

  function formatMoney(cents) {
    var fmt = CFG.moneyFormat || '{{amount_with_comma_separator}} €';
    var amount = (Math.max(0, cents) / 100).toFixed(2);
    var parts = amount.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return String(fmt).replace(/<[^>]*>/g, '')
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, intPart)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, intPart + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .trim();
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function tagCart(cart) {
    if (cart && cart.attributes && cart.attributes._rs_atc_variant === VARIANT) return;
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { _rs_atc_variant: VARIANT } })
    }).catch(function () {});
  }

  function refreshBubble() {
    fetch(root + '?sections=cart-icon-bubble')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var target = document.getElementById('cart-icon-bubble');
        if (!data || !data['cart-icon-bubble'] || !target) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = data['cart-icon-bubble'];
        var inner = tmp.querySelector('.shopify-section');
        target.innerHTML = inner ? inner.innerHTML : tmp.innerHTML;
      })
      .catch(function () {});
  }

  function goToCart() {
    window.location.href = cartUrl;
    return new Promise(function () {});
  }

  function goToCheckout() {
    window.location.href = checkoutUrl;
    return new Promise(function () {});
  }

  function goToSheetExit() {
    if (sheetExitToCheckout) return goToCheckout();
    if (sheetExitToCart) return goToCart();
    return null;
  }

  function primaryExitHref() {
    return sheetExitToCheckout ? checkoutUrl : cartUrl;
  }

  function primaryExitLabel(n, totalCents) {
    if (sheetExitToCheckout) {
      return 'Weiter zur Kasse · ' + formatMoney(totalCents == null ? 0 : totalCents);
    }
    return 'Weiter zum Warenkorb (' + n + ')';
  }

  function cartTotal(cart) {
    return cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
  }

  function savingsCents(cart) {
    var save = 0;
    (cart.items || []).forEach(function (item) {
      var cmp = item.original_price != null && item.compare_at_price
        ? Math.max(item.original_line_price, (item.compare_at_price || 0) * item.quantity)
        : item.original_line_price;
      if (item.compare_at_price && item.compare_at_price > item.price) {
        cmp = Math.max(cmp, item.compare_at_price * item.quantity);
      }
      save += Math.max(0, cmp - (item.final_line_price != null ? item.final_line_price : item.line_price));
    });
    if (cart.total_discount) save = Math.max(save, cart.total_discount);
    return save;
  }

  function hasFsCoupon(cart) {
    var codes = (cart.discount_codes || []).map(function (c) { return String(c.code || '').toUpperCase(); });
    if (codes.indexOf('ROTPROB') !== -1) return true;
    var apps = cart.cart_level_discount_applications || [];
    for (var i = 0; i < apps.length; i++) {
      if (apps[i].target_type === 'shipping_line') return true;
    }
    return false;
  }

  var toast = null;
  var backdrop = null;
  var busy = false;

  function ensureBackdrop() {
    if (backdrop) return backdrop;
    backdrop = document.createElement('div');
    backdrop.className = 'rs-atc-backdrop';
    backdrop.hidden = true;
    backdrop.setAttribute('aria-hidden', 'true');
    document.body.appendChild(backdrop);
    backdrop.addEventListener('click', function () {
      track('rs_toast_backdrop');
      if (closeDetailPanel()) return;
      if (goToSheetExit()) return;
      hide();
    });
    return backdrop;
  }

  function ensureToast() {
    if (toast) return toast;
    ensureBackdrop();
    toast = document.createElement('div');
    toast.className = 'rs-atc rs-atc--sheet';
    toast.setAttribute('role', 'dialog');
    toast.setAttribute('aria-modal', 'true');
    toast.setAttribute('aria-label', 'Noch etwas dazu?');
    toast.hidden = true;
    document.body.appendChild(toast);

    toast.addEventListener('click', function (e) {
      if (e.target.closest('[data-rs-ups-detail-back]')) {
        e.preventDefault();
        closeDetailPanel();
        return;
      }
      var detailHit = e.target.closest('[data-rs-ups-detail]');
      if (detailHit) {
        e.preventDefault();
        var card = detailHit.closest('.rc-ups__card');
        if (card) openDetailPanel(card);
        return;
      }
      if (e.target.closest('[data-rs-atc-skip]')) {
        e.preventDefault();
        track('rs_toast_skip_extras');
        goToCheckout();
        return;
      }
      if (e.target.closest('[data-rs-atc-close], [data-rs-atc-continue]')) {
        track(e.target.closest('[data-rs-atc-close]') ? 'rs_toast_close' : 'rs_toast_continue');
        if (closeDetailPanel()) return;
        if (goToSheetExit()) return;
        hide();
        return;
      }
      if (e.target.closest('[data-rs-atc-cart]')) {
        track(sheetExitToCheckout ? 'rs_toast_checkout' : 'rs_toast_cart');
        return;
      }
      var addBtn = e.target.closest('[data-upsell-add]');
      if (addBtn && !busy) {
        e.preventDefault();
        quickAdd(addBtn);
        return;
      }
      var detailAdd = e.target.closest('[data-rs-ups-detail-add]');
      if (detailAdd && !busy) {
        e.preventDefault();
        var vid = detailAdd.getAttribute('data-variant-id');
        var hostCard = toast.querySelector('.rc-ups__card[data-variant-id="' + vid + '"]');
        var real = hostCard && hostCard.querySelector('[data-upsell-add]');
        if (!real) {
          real = detailAdd;
          real.setAttribute('data-upsell-add', '');
        }
        quickAdd(real).then(function () { closeDetailPanel(); });
        return;
      }
      var qtyRoot = e.target.closest('[data-key]');
      if (!qtyRoot || busy) return;
      if (e.target.closest('[data-remove-line]')) {
        e.preventDefault();
        changeQty(qtyRoot, 0);
        return;
      }
      if (e.target.closest('[data-qty-decrease]')) {
        e.preventDefault();
        var cur = parseInt(qtyRoot.querySelector('[data-qty-input]').value, 10) || 1;
        changeQty(qtyRoot, Math.max(0, cur - 1));
        return;
      }
      if (e.target.closest('[data-qty-increase]')) {
        e.preventDefault();
        var cur2 = parseInt(qtyRoot.querySelector('[data-qty-input]').value, 10) || 1;
        changeQty(qtyRoot, cur2 + 1);
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !toast || toast.hidden) return;
      if (closeDetailPanel()) return;
      if (goToSheetExit()) return;
      hide();
    });
    return toast;
  }

  function parseDetailJson(card) {
    var node = card && card.querySelector('.rc-ups__detail-json');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (err) { return null; }
  }

  /* EU-14 allergens. A word is marked when it contains one of these stems (so compounds like
     "Vollmilchpulver" or "Knollensellerie" count); look-alikes that are not allergens are excluded. */
  var ALLERGEN_STEMS = /sellerie|senf|soja|sesam|weizen|dinkel|roggen|gerste|hafer|khorasan|kamut|gluten|milch|molke|sahne|butter|käse|joghurt|laktose|lactose|mandel|haselnu|walnu|cashew|pistazie|macadamia|paranu|pekannu|pecannu|schalenfrücht|erdnu|lupine|fisch|krebstier|garnele|krabbe|weichtier|schwefeldioxid|sulfit/;
  var ALLERGEN_EGG = /^(ei|eier|vollei\S*|eigelb\S*|eiklar\S*|eipulver\S*|hühnerei\S*)$/;
  var NOT_ALLERGEN = /milchsäure|kokosmilch|kakaobutter|sheabutter|buchweizen/;
  var WORD_RE = /[A-Za-zÀ-ÖØ-öø-ÿß]+/g;

  function isAllergenWord(word) {
    var w = word.toLowerCase();
    if (NOT_ALLERGEN.test(w)) return false;
    return ALLERGEN_EGG.test(w) || ALLERGEN_STEMS.test(w);
  }

  function highlightAllergens(text) {
    var marked = String(text == null ? '' : text).replace(WORD_RE, function (word) {
      return isAllergenWord(word) ? '\u0001' + word + '\u0002' : word;
    });
    marked = marked.replace(/\u0001(glutenhaltig\w*)\u0002(\s+)(Getreide\w*)/gi, '\u0001$1$2$3\u0002');
    return esc(marked).replace(/\u0001/g, '<strong>').replace(/\u0002/g, '</strong>');
  }

  var NUTRI_SPECS = [
    { key: 'Brennwert kJ', label: 'Brennwert', unit: 'kJ' },
    { key: 'Brennwert kcal', label: 'Brennwert', unit: 'kcal' },
    { key: 'Fett', label: 'Fett', unit: 'g' },
    { key: 'gesättigte Fettsäuren', label: 'davon gesättigte Fettsäuren', unit: 'g', sub: true },
    { key: 'Kohlenhydrate', label: 'Kohlenhydrate', unit: 'g' },
    { key: 'Zucker', label: 'davon Zucker', unit: 'g', sub: true },
    { key: 'Eiweiß', label: 'Eiweiß', unit: 'g' },
    { key: 'Salz', label: 'Salz', unit: 'g' }
  ];

  function nutritionHtml(raw) {
    var basis = raw.match(/auf\s*(\d+)\s*(ml|g)/i);
    var per = basis ? basis[1] + ' ' + basis[2].toLowerCase() : '100 g';
    var text = raw.replace(/^\s*Nährwerte\s*/i, '').replace(/auf\s*\d+\s*(ml|g)/gi, '').replace(/\s+/g, ' ').trim();
    var rows = [];
    NUTRI_SPECS.forEach(function (spec, i) {
      var start = text.search(new RegExp(spec.key, 'i'));
      if (start < 0) return;
      var next = NUTRI_SPECS[i + 1];
      var end = next ? text.search(new RegExp(next.key, 'i')) : -1;
      var seg = end > start ? text.slice(start + spec.key.length, end) : text.slice(start + spec.key.length);
      var m = seg.match(/(\d+(?:[.,]\d+)?)/);
      if (!m) return;
      var value = m[1].replace('.', ',') + ' ' + spec.unit;
      var prev = rows[rows.length - 1];
      if (prev && prev.label === spec.label) {
        prev.value += ' / ' + value;
        return;
      }
      rows.push({ label: spec.label, value: value, sub: !!spec.sub });
    });
    if (!rows.length) return '<p>' + esc(raw) + '</p>';
    return '<table class="rs-atc__nutri"><thead><tr><th scope="col">Durchschnittlich</th><th scope="col">pro ' + esc(per) + '</th></tr></thead>' +
      '<tbody>' + rows.map(function (row) {
        return '<tr' + (row.sub ? ' class="is-sub"' : '') + '><th scope="row">' + esc(row.label) + '</th><td>' + esc(row.value) + '</td></tr>';
      }).join('') + '</tbody></table>';
  }

  function openDetailPanel(card) {
    if (!toast) return;
    var data = parseDetailJson(card);
    if (!data) return;
    var panel = toast.querySelector('[data-rs-ups-panel]');
    var main = toast.querySelector('[data-rs-ups-main]');
    if (!panel || !main) return;
    var scrollBody = toast.querySelector('[data-rc-ups-body]');
    panel.dataset.rsScrollRestore = scrollBody ? String(scrollBody.scrollTop || 0) : '0';
    var meta = [data.size, data.portions ? ('ca. ' + data.portions + ' Portionen') : ''].filter(Boolean).join(' · ');
    var parts = [];
    parts.push('<div class="rs-atc__detail-scroll">');
    parts.push('<button type="button" class="rs-atc__detail-back" data-rs-ups-detail-back>‹ Zurück zur Auswahl</button>');
    parts.push('<div class="rs-atc__detail-top">');
    if (data.image) {
      parts.push('<img class="rs-atc__detail-img" src="' + esc(data.image) + '" alt="" width="160" height="160">');
    }
    parts.push('<div class="rs-atc__detail-meta">');
    parts.push('<h3 class="rs-atc__detail-title">' + esc(data.title || '') + '</h3>');
    if (meta) parts.push('<p class="rs-atc__detail-size">' + esc(meta) + '</p>');
    parts.push('<p class="rs-atc__detail-price"><strong>' + esc(data.price || '') + '</strong>');
    if (data.ppp) parts.push('<span class="rs-atc__detail-ppp">' + esc(data.ppp) + '/Portion</span>');
    parts.push('</p>');
    if (data.unitHtml) parts.push('<p class="rs-atc__detail-unit">' + data.unitHtml + '</p>');
    parts.push('</div></div>');
    if (data.zutaten) {
      parts.push('<section class="rs-atc__detail-block"><h4>Zutaten</h4><p>' + highlightAllergens(data.zutaten) + '</p></section>');
    }
    if (data.allergy) {
      parts.push('<section class="rs-atc__detail-block"><h4>Allergenhinweis</h4><p>' + highlightAllergens(data.allergy) + '</p></section>');
    }
    if (data.nutrition) {
      parts.push('<section class="rs-atc__detail-block"><h4>Nährwerte</h4>' + nutritionHtml(data.nutrition) + '</section>');
    }
    parts.push('</div>');
    if (data.variantId) {
      parts.push('<div class="rs-atc__detail-foot">' +
        '<button type="button" class="rs-atc__detail-add" data-rs-ups-detail-add data-variant-id="' + esc(String(data.variantId)) + '">' +
        'Hinzufügen · ' + esc(data.price || '') +
        '</button></div>');
    }
    panel.innerHTML = parts.join('');
    panel.hidden = false;
    main.hidden = true;
    panel.setAttribute('aria-hidden', 'false');
    main.setAttribute('aria-hidden', 'true');
    track('rs_toast_detail_open');
  }

  function closeDetailPanel() {
    if (!toast) return false;
    var panel = toast.querySelector('[data-rs-ups-panel]');
    var main = toast.querySelector('[data-rs-ups-main]');
    if (!panel || panel.hidden) return false;
    var restore = parseInt(panel.dataset.rsScrollRestore || '0', 10) || 0;
    panel.hidden = true;
    panel.innerHTML = '';
    panel.setAttribute('aria-hidden', 'true');
    if (main) {
      main.hidden = false;
      main.setAttribute('aria-hidden', 'false');
    }
    var scrollBody = toast.querySelector('[data-rc-ups-body]');
    if (scrollBody) scrollBody.scrollTop = restore;
    return true;
  }

  function hide() {
    if (!toast || toast.hidden) return;
    toast.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-open');
    unlockPageScroll();
    setTimeout(function () {
      toast.hidden = true;
      if (backdrop) backdrop.hidden = true;
    }, 220);
  }

  function renderBar(cart) {
    var total = cartTotal(cart);
    var unlocked = total >= FREE_SHIP || hasFsCoupon(cart);
    var remaining = Math.max(0, FREE_SHIP - total);
    var pct = unlocked ? 100 : Math.max(4, Math.min(100, Math.round((total / FREE_SHIP) * 100)));
    var msg = unlocked
      ? 'Kostenloser Versand ✓'
      : 'Noch <strong>' + esc(formatMoney(remaining)) + '</strong> bis zum kostenlosen Versand.';
    return {
      html: '<div class="rs-atc__ship' + (unlocked ? ' is-free' : '') + '" data-rs-ship data-remaining="' + remaining + '">' +
        '<p>' + msg + '</p>' +
        '<span class="rs-atc__bar" aria-hidden="true"><span style="width:' + pct + '%"></span></span>' +
        '</div>',
      remaining: remaining,
      unlocked: unlocked
    };
  }

  function syncScrollHint() {
    if (!toast) return;
    var wrap = toast.querySelector('[data-rs-scroll]');
    var body = toast.querySelector('[data-rc-ups-body]');
    var hint = toast.querySelector('[data-rs-scroll-hint]');
    if (!body || !hint) return;
    var canScroll = body.scrollHeight > body.clientHeight + 8;
    var atEnd = body.scrollTop + body.clientHeight >= body.scrollHeight - 8;
    var show = canScroll && !atEnd;
    hint.hidden = !show;
    hint.classList.toggle('is-on', show);
    if (wrap) wrap.classList.toggle('is-scroll-end', !show);
  }

  function labelFsCards(remaining) {
    if (!toast) return;
    toast.querySelectorAll('.rc-ups__card').forEach(function (card) {
      var price = parseInt(card.getAttribute('data-price-cents'), 10) || 0;
      var label = card.querySelector('.rc-ups__fs-label');
      if (!label) return;
      var show = remaining > 0 && price >= remaining;
      label.hidden = !show;
    });
  }

  function syncFooter(cart) {
    if (!toast) return;
    var countEl = toast.querySelector('[data-rs-count]');
    var totalEl = toast.querySelector('[data-rs-total]');
    var saveEl = toast.querySelector('[data-rs-save]');
    var cartBtn = toast.querySelector('[data-rs-atc-cart]');
    var n = cart.item_count || 0;
    var total = cartTotal(cart);
    var save = savingsCents(cart);
    if (countEl) countEl.textContent = n + ' Artikel';
    if (totalEl) totalEl.textContent = formatMoney(total);
    if (saveEl) {
      if (save > 0) {
        saveEl.hidden = false;
        saveEl.textContent = 'Du sparst ' + formatMoney(save);
      } else {
        saveEl.hidden = true;
      }
    }
    if (cartBtn) {
      cartBtn.textContent = primaryExitLabel(n, total);
      cartBtn.setAttribute('href', primaryExitHref());
    }
    var ship = toast.querySelector('[data-rs-ship]');
    if (ship) {
      var bar = renderBar(cart);
      ship.outerHTML = bar.html;
      requestAnimationFrame(function () {
        var fill = toast.querySelector('.rs-atc__bar span');
        if (fill) {
          fill.style.width = '0%';
          requestAnimationFrame(function () { fill.style.width = (bar.unlocked ? 100 : Math.max(4, Math.min(100, Math.round((total / FREE_SHIP) * 100)))) + '%'; });
        }
      });
      labelFsCards(bar.remaining);
    }
  }

  function stepperHtml(key, qty, title) {
    return '<div class="rc-ups__qty" data-key="' + esc(key) + '">' +
      '<input type="hidden" data-qty-input value="' + qty + '">' +
      '<button type="button" class="rc-ups__del" data-remove-line aria-label="' + esc(title) + ' entfernen">×</button>' +
      '<div class="rc-ups__stepper">' +
      '<button type="button" data-qty-decrease aria-label="Menge verringern">−</button>' +
      '<span aria-live="polite">' + qty + '</span>' +
      '<button type="button" data-qty-increase aria-label="Menge erhöhen">+</button>' +
      '</div></div>';
  }

  function findLine(cart, variantId) {
    variantId = Number(variantId);
    return (cart.items || []).filter(function (i) {
      return Number(i.variant_id) === variantId && (i.final_line_price == null || i.final_line_price > 0);
    })[0] || null;
  }

  function cardActionHost(card) {
    if (!card) return null;
    return card.querySelector('.rc-ups__action') || card.querySelector('.rc-ups__media');
  }

  function quickAdd(btn) {
    var vid = btn.getAttribute('data-variant-id');
    var card = btn.closest('.rc-ups__card');
    var title = (card && card.querySelector('.rc-ups__name') && card.querySelector('.rc-ups__name').textContent) || '';
    busy = true;
    btn.disabled = true;
    btn.textContent = '✓';
    track('rs_toast_gap_add');
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () { return getCart(); })
      .then(function (cart) {
        var line = findLine(cart, vid);
        var host = cardActionHost(card);
        if (host && line) {
          var add = host.querySelector('[data-upsell-add]');
          if (add) add.remove();
          var existingQty = host.querySelector('.rc-ups__qty');
          if (existingQty) existingQty.remove();
          host.insertAdjacentHTML('beforeend', stepperHtml(line.key, line.quantity, title));
        }
        syncFooter(cart);
        refreshBubble();
        return cart;
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = '+';
      })
      .finally(function () { busy = false; });
  }

  function changeQty(qtyRoot, quantity) {
    var key = qtyRoot.getAttribute('data-key');
    var card = qtyRoot.closest('.rc-ups__card');
    busy = true;
    fetch(root + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (cart) {
        if (quantity <= 0) {
          if (card) {
            var host = cardActionHost(card);
            var vid = card.getAttribute('data-variant-id');
            qtyRoot.remove();
            if (host && !host.querySelector('[data-upsell-add]')) {
              host.insertAdjacentHTML('beforeend',
                '<button type="button" class="rc-ups__add" data-upsell-add data-variant-id="' + esc(vid) + '" aria-label="Hinzufügen">+</button>');
            }
          }
        } else {
          var input = qtyRoot.querySelector('[data-qty-input]');
          var span = qtyRoot.querySelector('.rc-ups__stepper span');
          if (input) input.value = quantity;
          if (span) span.textContent = quantity;
        }
        syncFooter(cart);
        refreshBubble();
      })
      .catch(function () {})
      .finally(function () { busy = false; });
  }

  function cartProductIds(cart) {
    var ids = {};
    ((cart && cart.items) || []).forEach(function (item) {
      if (item && item.product_id) ids[String(item.product_id)] = true;
    });
    return ids;
  }

  function seedProductIds(cart) {
    var seeds = [];
    var items = (cart && cart.items) || [];
    for (var i = items.length - 1; i >= 0; i--) {
      var pid = items[i] && items[i].product_id;
      if (!pid) continue;
      var key = String(pid);
      if (seeds.indexOf(key) !== -1) continue;
      seeds.push(key);
      if (seeds.length >= 2) break;
    }
    return seeds;
  }

  function fetchRecSection(productId, intent) {
    var url = root + 'recommendations/products?product_id=' + encodeURIComponent(productId) +
      '&limit=10&intent=' + encodeURIComponent(intent) +
      '&section_id=rs-upsell-recs';
    return fetch(url, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) {
        if (!r.ok) return '';
        return r.text();
      })
      .then(function (text) {
        if (!text) return '';
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var wrap = doc.querySelector('[data-rs-upsell-recs]');
        return wrap ? wrap.innerHTML : '';
      })
      .catch(function () { return ''; });
  }

  function fetchHeuristicBody() {
    return fetch(cartUrl + '?view=upsell', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('ups'); return r.text(); });
  }

  var UPS_MAX = 3;

  function mergeUpsellCards(chunks, excludeIds) {
    var ul = document.createElement('ul');
    ul.className = 'rc-ups__grid rc-ups__grid--stack';
    ul.setAttribute('role', 'list');
    var seen = {};
    var count = 0;
    chunks.forEach(function (html) {
      if (!html || count >= UPS_MAX) return;
      var doc = new DOMParser().parseFromString('<div>' + html + '</div>', 'text/html');
      doc.querySelectorAll('.rc-ups__card').forEach(function (card) {
        if (count >= UPS_MAX) return;
        var pid = card.getAttribute('data-product-id') || '';
        if (!pid || seen[pid] || excludeIds[pid]) return;
        seen[pid] = true;
        ul.appendChild(card);
        count += 1;
      });
    });
    if (!ul.querySelector('.rc-ups__card')) {
      return '<li class="rc-ups__empty">Hier gibt es gerade nichts Neues.</li>';
    }
    return ul.outerHTML;
  }

  function loadBody(cart) {
    var exclude = cartProductIds(cart);

    if (sheetExitToCheckout) {
      return fetchHeuristicBody().then(function (html) {
        return mergeUpsellCards([html], exclude);
      }).catch(function () {
        return '<li class="rc-ups__empty">Hier gibt es gerade nichts Neues.</li>';
      });
    }

    var seeds = seedProductIds(cart);
    var jobs = [];
    seeds.forEach(function (pid) {
      jobs.push(fetchRecSection(pid, 'complementary'));
    });
    if (seeds[0]) jobs.push(fetchRecSection(seeds[0], 'related'));

    return Promise.all(jobs).then(function (chunks) {
      var html = mergeUpsellCards(chunks, exclude);
      var count = (html.match(/rc-ups__card/g) || []).length;
      if (count >= UPS_MAX) return html;
      return fetchHeuristicBody().then(function (fallback) {
        return mergeUpsellCards(chunks.concat([fallback]), exclude);
      });
    }).catch(function () {
      return fetchHeuristicBody().then(function (html) {
        return mergeUpsellCards([html], exclude);
      });
    });
  }

  function showSheet(cart, opts) {
    sheetExitToCart = !!(opts && opts.exitToCart);
    sheetExitToCheckout = !!(opts && opts.exitToCheckout);
    if (sheetExitToCheckout) {
      try { document.documentElement.dataset.rsOfferJourney = '1'; } catch (e) {}
    }
    var el = ensureToast();
    el.classList.toggle('rs-atc--checkout', sheetExitToCheckout);
    var bd = ensureBackdrop();
    var bar = renderBar(cart);
    var save = savingsCents(cart);
    var n = cart.item_count || 0;
    var total = cartTotal(cart);
    var hideContinue = sheetExitToCart || sheetExitToCheckout;
    var skipExtras = sheetExitToCheckout
      ? '<button type="button" class="rs-atc__skip" data-rs-atc-skip>Ohne Extras zur Kasse</button>'
      : '';

    el.innerHTML =
      '<div class="rs-atc__head">' +
        '<h2 class="rs-atc__title">Noch etwas dazu?</h2>' +
        '<button type="button" class="rs-atc__x" data-rs-atc-close aria-label="Schließen">' +
          '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M5 5L15 15M15 5L5 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
        '</button>' +
      '</div>' +
      '<div class="rs-atc__main" data-rs-ups-main>' +
        bar.html +
        '<div class="rs-atc__scroll" data-rs-scroll>' +
          '<div class="rs-atc__body" data-rc-ups-body><p class="rs-atc__loading">Wird geladen …</p></div>' +
          '<div class="rs-atc__fade" aria-hidden="true"></div>' +
          '<p class="rs-atc__scroll-hint" data-rs-scroll-hint hidden>↓ Mehr Produkte weiter unten</p>' +
        '</div>' +
        '<div class="rs-atc__foot">' +
          '<div class="rs-atc__sum">' +
            '<span data-rs-count>' + esc(String(n)) + ' Artikel</span>' +
            '<strong data-rs-total>' + esc(formatMoney(total)) + '</strong>' +
            '<span class="rs-atc__save" data-rs-save' + (save > 0 ? '' : ' hidden') + '>' +
              (save > 0 ? 'Du sparst ' + esc(formatMoney(save)) : '') +
            '</span>' +
          '</div>' +
          '<a href="' + esc(primaryExitHref()) + '" class="rs-atc__cart" data-rs-atc-cart>' +
            esc(primaryExitLabel(n, total)) +
          '</a>' +
          skipExtras +
          (hideContinue ? '' : '<button type="button" class="rs-atc__continue" data-rs-atc-continue>Weiter einkaufen</button>') +
        '</div>' +
      '</div>' +
      '<div class="rs-atc__panel" data-rs-ups-panel hidden aria-hidden="true"></div>';

    bd.hidden = false;
    el.hidden = false;
    void el.offsetWidth;
    lockPageScroll();
    bd.classList.add('is-open');
    el.classList.add('is-open');
    track('rs_toast_show');

    loadBody(cart).then(function (html) {
      var body = el.querySelector('[data-rc-ups-body]');
      if (!body) return;
      body.innerHTML = html;
      var cards = body.querySelectorAll('.rc-ups__card');
      if (!cards.length) {
        body.innerHTML = '<p class="rs-atc__empty">Dein Warenkorb ist aktualisiert. Du kannst jetzt zur Kasse.</p>';
        var hint = el.querySelector('[data-rs-scroll-hint]');
        var fade = el.querySelector('.rs-atc__fade');
        if (hint) hint.hidden = true;
        if (fade) fade.hidden = true;
        return;
      }
      labelFsCards(bar.remaining);
      if (!body._rsScrollBound) {
        body._rsScrollBound = true;
        body.addEventListener('scroll', syncScrollHint, { passive: true });
      }
      requestAnimationFrame(syncScrollHint);
    }).catch(function () {
      var body = el.querySelector('[data-rc-ups-body]');
      if (body) {
        body.innerHTML = '<p class="rs-atc__empty">Dein Warenkorb ist aktualisiert. Du kannst jetzt zur Kasse.</p>';
      }
      var hint = el.querySelector('[data-rs-scroll-hint]');
      var fade = el.querySelector('.rs-atc__fade');
      if (hint) hint.hidden = true;
      if (fade) fade.hidden = true;
    });
  }

  function showFromCart(opts) {
    return getCart().then(function (cart) {
      tagCart(cart);
      refreshBubble();
      showSheet(cart, opts);
      return cart;
    });
  }

  function showAddingShell() {
    var el = ensureToast();
    var bd = ensureBackdrop();
    if (!el) return;
    if (!el.querySelector('[data-rc-ups-body]')) {
      el.innerHTML =
        '<div class="rs-atc__head">' +
          '<h2 class="rs-atc__title">Warenkorb</h2>' +
          '<button type="button" class="rs-atc__x" data-rs-atc-close aria-label="Schließen">' +
            '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M5 5L15 15M15 5L5 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="rs-atc__main" data-rs-ups-main>' +
          '<div class="rs-atc__scroll"><div class="rs-atc__body" data-rc-ups-body>' +
            '<p class="rs-atc__loading" role="status">Wird hinzugefügt …</p>' +
          '</div></div>' +
        '</div>' +
        '<div class="rs-atc__panel" data-rs-ups-panel hidden aria-hidden="true"></div>';
    } else {
      var body = el.querySelector('[data-rc-ups-body]');
      var main = el.querySelector('[data-rs-ups-main]');
      var panel = el.querySelector('[data-rs-ups-panel]');
      if (panel) {
        panel.hidden = true;
        panel.setAttribute('aria-hidden', 'true');
      }
      if (main) {
        main.hidden = false;
        main.setAttribute('aria-hidden', 'false');
      }
      if (body) {
        body.innerHTML = '<p class="rs-atc__loading" role="status">Wird hinzugefügt …</p>';
      }
    }
    if (bd) {
      bd.hidden = false;
      bd.classList.add('is-open');
    }
    el.hidden = false;
    requestAnimationFrame(function () {
      el.classList.add('is-open');
      lockPageScroll();
    });
  }

  function add(variantId, quantity, source) {
    var q = Math.max(1, parseInt(quantity, 10) || 1);
    var id = Number(variantId);
    if (!id || !isFinite(id)) {
      return Promise.reject({
        status: 'bad_request',
        message: 'Produktvariante fehlt',
        description: 'Produktvariante fehlt – bitte Seite neu laden.'
      });
    }
    /* Immediate sheet so collection/PDP taps never feel dead while /cart/add.js runs */
    showAddingShell();
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: q }] })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        track('rs_add_to_cart', 'rs_atc_source', source || 'unknown');
        var item = data && data.items ? data.items[0] : data;

        /* Always sheet after RSCart.add. 3er/5er never call this — they go to dein-set. */
        try {
          sessionStorage.setItem(PENDING_KEY, JSON.stringify({
            key: item && item.key,
            path: window.location.pathname,
            ts: Date.now()
          }));
        } catch (e) {}
        return showFromCart().then(function (cart) {
          return { item: item, cart: cart };
        });
      });
    }).catch(function (err) {
      if (toast) {
        var body = toast.querySelector('[data-rc-ups-body]');
        if (body) {
          body.innerHTML = '<p class="rs-atc__empty" role="alert">Hinzufügen fehlgeschlagen. Bitte erneut versuchen.</p>';
        }
      }
      throw err;
    });
  }

  function refresh(openAfter, opts) {
    if (!openAfter) {
      refreshBubble();
      return Promise.resolve();
    }
    return showFromCart(opts);
  }

  try {
    var pending = JSON.parse(sessionStorage.getItem(PENDING_KEY) || 'null');
    sessionStorage.removeItem(PENDING_KEY);
    if (pending && pending.path === window.location.pathname && Date.now() - pending.ts < 10000) {
      showFromCart();
    }
  } catch (e) {}

  window.RSCart = {
    add: add,
    open: function (opts) { return refresh(true, opts); },
    close: hide,
    refresh: refresh,
    variant: VARIANT
  };
})();
